import { AdminPage } from "./AdminPage";

type PlaceholderPageProps = {
	title: string;
	subtitle?: string;
};

export function PlaceholderPage({ title, subtitle }: PlaceholderPageProps) {
	return <AdminPage title={title} subtitle={subtitle} card={false} />;
}
